    // "Casos 2026" nav dropdown: the Primary nav item whose label starts with
    // "Casos" or "Desafíos" opens a panel of tagged pages and a final link to the
    // same summary page configured on the nav item in Ghost Admin.
    //
    // This file NEVER creates, moves or removes a node inside the nav, and it never
    // hides anything while it loads. Both halves of the dropdown are in the response
    // and therefore in the first paint:
    //   - the panel, rendered by default.hbs as a sibling of the `ul.nav` that
    //     {{navigation}} produces,
    //   - the caret, a CSS ::after on the item's own <li> (block 4.9 of
    //     assets/css/screen.css, keyed by the `nav-<slug>` class Ghost derives from
    //     the label), so the item is exactly as wide with the caret as without it and
    //     the navbar never reflows once the browser has painted it.
    // All that is left here is state and geometry:
    //   - find the item by its label and keep its <li> and <a>,
    //   - add the disclosure aria attributes to the <a> (attributes, no layout
    //     effect, so they can land after the paint without moving anything),
    //   - point the panel at the item by writing --cases-nav-left and
    //     --cases-nav-top, the only layout input, and only while the panel is shut,
    //   - toggle `is-cases-nav-open` on <body> (Casper's own convention, like
    //     is-dropdown-open and gh-head-open) and handle the keyboard.
    //
    // The label and caret both open the panel on a primary click. The label remains
    // an anchor to the summary page for no-JS and modified-click fallback; its URL
    // is also copied to the final "Todos los desafíos" link in the panel. The caret
    // is a ::after on the <li>, so its click target is the <li>, while the label's
    // target is the <a>.
    //
    // A submenu cannot be nested inside the nav item, because {{navigation}} emits a
    // flat list with no hook inside an <li> (see
    // versions/<ghost>/core/frontend/helpers/tpl/navigation.hbs). Positioning a
    // sibling is what allows server rendering at the cost of measuring instead of
    // inheriting the geometry, so the measurement is redone whenever the item can
    // have moved: on open, on resize, and once the web font lands.
    //
    // Two Casper details this has to live with (both in assets/js/dropdown.js):
    //  1. Its resize handler restores `nav.innerHTML` from a snapshot, which
    //     REPLACES every nav node, so bind() re-resolves the item and re-attaches on
    //     a debounced resize. The panel is a sibling of that <ul>, so the restore
    //     cannot touch it.
    //  2. Its "More" overflow moves trailing nav items into a .gh-dropdown that lives
    //     INSIDE the .nav-more-toggle <button>, roughly below 900px with the current
    //     six nav items. Two consequences: findItem() looks at nested <li> too, and
    //     the click on the caret has to stop propagating or Casper's button listener
    //     closes the More menu that contains us.
(function () {
    // Which nav item becomes the dropdown. The visible name lives here and the
    // tag lives in default.hbs, so neither depends on the other; Ghost matches
    // the tag slug, hence the hyphenated name in the template and not here.
    // Deliberately tolerant so renaming the item in Admin ("Casos 2026" /
    // "Desafíos 2026") does not silently break the dropdown. First match wins,
    // so do not add a second item starting with the same word.
    // The caret in the CSS matches the same two words through the `nav-<slug>`
    // class Ghost derives from this label, so the two have to move together.
    var LABEL = /^(casos|desafíos)/i;

    var MENU_ID = 'gh-head-menu';
    var PANEL_ID = 'cases-nav-dropdown';
    var OPEN_CLASS = 'is-cases-nav-open';
    var MOBILE = '(max-width: 767px)';
    // Distance from the bottom of the item to the top of the panel. The item only
    // spans its own label plus the caret inside the 50px pill, so the gap has to
    // clear the rest of the bar: measured 26px leaves the panel 11px under it.
    var GAP = 26;
    var GAP_MOBILE = 8;
    // Casper restores nav.innerHTML from a 1ms timeout, so this has to be
    // longer than that to see the restored nodes.
    var RESIZE_DEBOUNCE = 80;

    var menu = document.getElementById(MENU_ID);
    var panel = document.getElementById(PANEL_ID);
    // No panel means no page carries the tag: leave the navigation alone.
    if (!menu || !panel) return;

    var link = null;   // the item's <a>, used as fallback and summary destination
    var allLink = panel.querySelector('.cases-nav-all');
    var item = null;   // the <li> around it, owner of the caret ::after
    var bound = null;  // the <li> the listener is currently attached to

    function normalise(text) {
        return (text || '').replace(/\s+/g, ' ').trim();
    }

    function isOpen() {
        return document.body.classList.contains(OPEN_CLASS);
    }

    function setOpen(open) {
        if (open) measure();
        document.body.classList.toggle(OPEN_CLASS, open);
        if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function gap() {
        return window.matchMedia(MOBILE).matches ? GAP_MOBILE : GAP;
    }

    // The offset of the panel inside the nav. Written as custom properties so the
    // placement is a plain CSS concern and the stylesheet keeps the geometry.
    // Measured from the whole <li> (label plus caret) rather than the label alone,
    // so the panel lines up with everything that is visible.
    function measure() {
        if (!item) return;

        var m = menu.getBoundingClientRect();
        var t = item.getBoundingClientRect();
        var w = panel.offsetWidth;
        var h = panel.offsetHeight;
        var top = t.bottom - m.top + gap();

        // The burger overlay is a scroll container and the nav is a column, so the
        // item sits near the bottom of it: a panel hanging below would need
        // scrolling to be read. Open upwards in that case instead, so every entry
        // stays reachable. The clamp below keeps it inside the nav row.
        if (window.matchMedia(MOBILE).matches) {
            var head = menu.closest('.gh-head');
            var limit = head.getBoundingClientRect().bottom - m.top;
            if (top + h > limit) top = Math.max(0, t.top - m.top - h - gap());
        }

        // Horizontally the panel is kept inside the nav row, which is what stops it
        // running off the edge of the viewport on narrow screens.
        var left = Math.max(0, Math.min(t.left - m.left, m.width - w));
        panel.style.setProperty('--cases-nav-left', Math.round(left) + 'px');
        panel.style.setProperty('--cases-nav-top', Math.round(top) + 'px');
    }

    // Move the focus to a submenu item, wrapping around at both ends.
    function focusItem(step) {
        var links = panel.querySelectorAll('a');
        if (!links.length) return;
        var current = Array.prototype.indexOf.call(links, document.activeElement);
        var next = current === -1
            ? (step > 0 ? 0 : links.length - 1)
            : (current + step + links.length) % links.length;
        links[next].focus();
    }

    // Bound to the nav, not to the item, so it also fires while the focus sits on
    // the label or on one of the submenu links. Tabbing out is handled by focusout.
    function onKeydown(e) {
        var inPanel = panel.contains(document.activeElement);

        // Enter activates the focused nav link, whose click handler opens the panel.
        // Space also toggles it without scrolling the page under the panel.
        if (e.key === ' ' && !inPanel) {
            setOpen(!isOpen());
            e.preventDefault();
            return;
        }

        if (e.key === 'Escape' && isOpen()) {
            setOpen(false);
            // Back to the label: it is the only focusable thing in the item and the
            // node that carries aria-haspopup / aria-expanded, so it is the control
            // that owns the panel.
            link.focus();
            e.preventDefault();
            return;
        }

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            var step = e.key === 'ArrowDown' ? 1 : -1;
            if (!isOpen()) setOpen(true);
            focusItem(step);
            e.preventDefault();
            return;
        }

        if (inPanel && (e.key === 'Home' || e.key === 'End')) {
            var links = panel.querySelectorAll('a');
            links[e.key === 'Home' ? 0 : links.length - 1].focus();
            e.preventDefault();
        }
    }

    function onFocusOut(e) {
        // relatedTarget is null when the focus leaves the document entirely
        if (!menu.contains(e.relatedTarget)) setOpen(false);
    }

    function onClick(e) {
        if (isOpen() && !menu.contains(e.target)) setOpen(false);
    }

    // The <li> is the listener because the caret is its ::after. A primary click on
    // either hit zone opens the panel; modified clicks on the anchor keep its Admin
    // URL behavior. The panel remains a sibling, so no node is injected into the
    // nav and its first-paint geometry stays unchanged.
    function onItemClick(e) {
        var clickedLink = link.contains(e.target);
        if (e.target !== item && !clickedLink) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        if (clickedLink) e.preventDefault();
        // When the "More" overflow has nested this item, our <li> is a DESCENDANT of
        // Casper's toggle <button>, whose own click listener toggles the whole menu.
        // Without stopping the event here, opening our panel would close the More
        // menu that contains it, i.e. it would close itself.
        if (item.closest('.nav-more-toggle')) e.stopPropagation();
        setOpen(!isOpen());
    }

    // The nav item is found by its label, because Ghost gives a nav item no id and
    // no data attribute. The `nav-<slug>` class it does render is derived from that
    // same label (it is what the caret ::after is keyed on in the stylesheet), so
    // this regex and those selectors have to move together when the item is renamed.
    // Every <li> inside `.nav` is considered, not only the direct children, so the
    // item keeps working when the "More" overflow has moved it into the nested menu.
    function findItem() {
        var items = menu.querySelectorAll('.nav li');
        for (var i = 0; i < items.length; i++) {
            var a = items[i].querySelector(':scope > a');
            if (a && LABEL.test(normalise(a.textContent))) return items[i];
        }
        return null;
    }

    // (Re)attach to the current item. The node identity check is what makes the
    // resize path cheap, and setOpen(false) resets the state that belonged to the
    // previous copy: after dropdown.js restores nav.innerHTML the old nodes are gone,
    // so the open state cannot be carried over to the new ones.
    function bind() {
        var found = findItem();
        if (found === bound) return;

        bound = found;
        item = found;
        link = found ? found.querySelector(':scope > a') : null;
        setOpen(false);
        if (!link) return;

        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-controls', PANEL_ID);
        if (allLink) allLink.setAttribute('href', link.getAttribute('href'));
        item.addEventListener('click', onItemClick);
    }

    function onResize() {
        window.clearTimeout(onResize.timer);
        onResize.timer = window.setTimeout(function () {
            bind();
            measure();
        }, RESIZE_DEBOUNCE);
    }

    function start() {
        bind();
        measure();

        menu.addEventListener('keydown', onKeydown);
        menu.addEventListener('focusout', onFocusOut);
        window.addEventListener('click', onClick);
        window.addEventListener('resize', onResize);

        // Montserrat is loaded with font-display:swap, so the label can change
        // width after the first paint, which moves the item and invalidates the
        // measured offset. Images can do the same.
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
        window.addEventListener('load', function () {
            bind();
            measure();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
